import { DOCUMENT } from '@angular/common';
import { PaymentUtilService } from './../../../common/payment/services/payment-util/payment-util.service';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-utm-popup',
  templateUrl: './utm-popup.component.html',
  styleUrls: ['./utm-popup.component.scss']
})
export class UtmPopupComponent implements OnInit {

  constructor(
    public paymentUtilService: PaymentUtilService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
  }

  activateHundredRs() {
    this.paymentUtilService.utmProceedClicked = true;
    this.dialog.closeAll();
    setTimeout(() => {
      window.scrollTo({ top: 1000, behavior: 'smooth' });
    }, 500);
  }

}
